import { render } from "./InputMultiplyPhone.vue?vue&type=template&id=5b195645"
import script from "./InputMultiplyPhone.vue?vue&type=script&lang=js"
export * from "./InputMultiplyPhone.vue?vue&type=script&lang=js"

import exportComponent from "/srv/www/nahodka.xpage.dev/htdocs/public/local/client-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__